import React from 'react'
import '../Project.css';
import { Parallax } from 'react-parallax';
import Image1 from '../../Gemco-Website-Images/projects/Hilton-_RAK_(retrofit).webp';

const Project_twelve = () => {

  return (
     <>
    
          <div className='project_1_work' id="workBanner">
    
            <div className="container project_our_work">
    
              <div className="heading">
                <h1>Hilton Resort Ras Al Khaimah</h1>
              </div>
    
              <hr></hr>
              <div className='project_section'>
                <div className="project_section_content">
                  <h1 className="project_scope">Scope of Work</h1>
                  <p>A major MEP retrofit project at the Hilton Resort in Ras Al Khaimah — a beachfront property and one of RAK's premier leisure
                      destinations. Works were executed in a live hotel environment with zero operational disruption to guests.</p>
                  <p>MAIN CONTRACTOR : ALEC</p>
                  <p>MEP CONTRACTOR : -</p>
                  <p>GEMCO SCOPE OF WORKS : Major retrofit of CHW and electrical systems — full
                    mechanical and electrical upgrade in live hotel
                    environment</p>
                  {/* <h2 className="project_years">2014 – 2022</h2> */}
                </div>
                <div className='project_1_card'>
                  <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
                </div>
              </div>
            </div>
          </div>
    
        </>

  )
}

export default Project_twelve